import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "./Home.module.css";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  // 如果已登录则跳转（可根据需求调整）
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      navigate("/survey");
    }
  }, [navigate]);

  const handleSendRequest = async () => {
    if (!email) {
      setMessage("メールアドレスを入力してください。");
      return;
    }
    setMessage("送信中...");

    try {
      const res = await axios.post(
        "https://api.nagae.biz/api/forgot-password",
        { email },
        { headers: { "Content-Type": "application/json" } }
      );
      setMessage(res.data.message);
      // 将邮箱保存到 sessionStorage，便于后续重置密码时使用
      sessionStorage.setItem("resetEmail", email);
      setTimeout(() => {
        navigate("/reset-password");
      }, 1000);
    } catch (error) {
      if (error.response) {
        setMessage(error.response.data.detail || "エラーが発生しました。");
      } else {
        setMessage("サーバーに接続できません。");
      }
    }
  };

  return (
    <div className={styles.container}>
      <img src="" alt="背景画像" className={styles.backgroundImage} />
      <div className={styles.content}>
        <header className={styles.header}>
          <h1 className={styles.title}>パスワードリセット</h1>
        </header>
        <div className={styles.card}>
          <input
            type="email"
            className={styles.input}
            style={{
              width: "90%",
              padding: "12px",
              fontSize: "1rem",
              marginBottom: "50px",
            }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="example@email.com"
            required
          />
          <button
            onClick={handleSendRequest}
            className={`${styles.btn} ${styles.btnPrimary}`}
          >
            リセットコード送る
          </button>
          <p className={styles.message}>{message}</p>
          <button
            onClick={() => navigate("/login")}
            className={`${styles.btn} ${styles.btnSecondary}`}
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
